module.exports = __webpack_public_path__ + "static/media/brinq_featured_products.bfb1320f.jpg";